<template>
  <div>
    <div class="d-print-none">
      <p class="fs-lg font-weight-bold">
        <b-icon icon="info-circle" class="mr-1" />
        Kalkulácia slúži ako pomôcka pre odberateľa a nemožno ju chápať ako
        odporúčanie alebo návod.
      </p>
    </div>
    <b-row>
      <b-col md="6">
        <b-card class="mb-4 mr-print-20" title="Prepočet hlavného ističa na RK">
          <b-form class="mb-2 d-print-none">
            <b-form-group
              label="Hodnota hlavného ističa (A)"
              label-cols-sm="7"
              label-for="mainBreaker"
            >
              <vue-autonumeric
                v-model="input.mainBreaker"
                placeholder="Zadajte"
                :options="{
                  decimalCharacter: ',',
                  digitGroupSeparator: ' ',
                  decimalPlaces: 0,
                  minimumValue: 0,
                  emptyInputBehavior: 'null',
                }"
                class="form-control text-right"
              />
            </b-form-group>
            <b-form-group
              label="Počet fáz na OM (1f/3f)"
              label-cols-sm="7"
              label-for="primaryPhase"
            >
              <b-form-select v-model="input.primaryPhase" :select-size="1">
                <option :value="null">--Zvolte--</option>
                <option
                  v-for="(item, key) in selection.phase"
                  :key="key"
                  :value="key"
                >
                  {{ item }}
                </option>
              </b-form-select>
            </b-form-group>
          </b-form>
          <table class="table d-none d-print-table">
            <tr>
              <td>Hodnota hlavného ističa (A)</td>
              <td class="text-right">
                {{ input.mainBreaker | formatNumber }}
              </td>
            </tr>
            <tr>
              <td>Počet fáz na OM (1f/3f)</td>
              <td class="text-right">
                {{ selection.phase[input.primaryPhase] }}
              </td>
            </tr>
          </table>
          <template v-if="inputReadyA">
            <h5
              class="mt-3 fs-lg text-right text-print-left text-primary font-weight-bold"
            >
              <small class="fs-base">Prepočet na RK - maximálna (kW):</small>
              {{ summary.maximum | formatNumber }}
            </h5>
            <h5
              class="mt-3 fs-lg text-right text-print-left text-primary font-weight-bold"
            >
              <small class="fs-base"
                >Minimálna hranica RK = 20% MRK (kW):</small
              >
              {{ summary.minimum | formatNumber }}
            </h5>
          </template>
        </b-card>
      </b-col>
      <b-col md="6">
        <b-card
          class="mb-4 ml-print-20"
          title="Opačný prepočet RK na hlavný istič"
        >
          <b-form class="mb-2 d-print-none">
            <b-form-group
              label="Hodnota RK (kW)"
              label-cols-sm="7"
              label-for="rk"
            >
              <vue-autonumeric
                v-model="input.rk"
                placeholder="Zadajte"
                :options="{
                  decimalCharacter: ',',
                  digitGroupSeparator: ' ',
                  decimalPlaces: 0,
                  minimumValue: 0,
                  emptyInputBehavior: 'null',
                }"
                class="form-control text-right"
              />
            </b-form-group>
            <b-form-group
              label="Počet fáz na OM (1f/3f)"
              label-cols-sm="7"
              label-for="secondaryPhase"
            >
              <b-form-select v-model="input.secondaryPhase" :select-size="1">
                <option :value="null">--Zvolte--</option>
                <option
                  v-for="(item, key) in selection.phase"
                  :key="key"
                  :value="key"
                >
                  {{ item }}
                </option>
              </b-form-select>
            </b-form-group>
          </b-form>
          <table class="table d-none d-print-table">
            <tr>
              <td>Hodnota RK (kW)</td>
              <td class="text-right">
                {{ input.rk | formatNumber }}
              </td>
            </tr>
            <tr>
              <td>Počet fáz na OM (1f/3f)</td>
              <td class="text-right">
                {{ selection.phase[input.secondaryPhase] }}
              </td>
            </tr>
          </table>
          <h5
            v-if="inputReadyB"
            class="mt-3 fs-lg text-right text-primary font-weight-bold"
          >
            <small class="fs-base">Prepočet na hlavný istič (A):</small>
            {{ summary.mainBreaker | formatNumber }}
          </h5>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
export default {
  data() {
    return {
      loading: false,
      input: {
        mainBreaker: null,
        primaryPhase: null,
        secondaryPhase: null,
        rk: null,
      },
      summary: {
        maximum: null,
        minimum: null,
        mainBreaker: null,
      },
    }
  },
  computed: {
    selection() {
      return {
        phase: {
          3: '1f',
          1: '3f',
        },
      }
    },
    inputReadyA() {
      return this.input.mainBreaker && this.input.primaryPhase
    },
    inputReadyB() {
      return this.input.rk && this.input.secondaryPhase
    },
  },
  watch: {
    input: {
      deep: true,
      handler() {
        this.calc()
      },
    },
  },
  methods: {
    calc() {
      this.summary.maximum =
        this.input.mainBreaker / 1.519 / this.input.primaryPhase
      this.summary.minimum = (this.summary.maximum / 100) * 20

      this.summary.mainBreaker =
        this.input.rk * 1.519 * this.input.secondaryPhase
    },
    reset() {
      Object.assign(this.$data, this.$options.data())
    },
  },
}
</script>
